export enum CustomRendererBehaviour {
  Default = 10,
  Standalone = 20,
}
